import {
  setCancellationErrorPageInfo,
  setCancellationSuccessPageInfo,
  setErrorEvent,
  setBopisCancelError,
} from './gatherService';
import { ERRORS, ONLINE_STORE_ID } from '../constants';
import {
  findMethodByFulfillment,
  findZipCodeByFulfillment,
} from '../utils/fulfillment';

const { LINE_ITEM_ERROR_CODE, CANCEL_LINE_ITEM, CANCEL_GENERAL } = ERRORS;

const createCancelFulfillmentAnalytics = (
  storeId: string,
  fulfillment: Object
) => {
  const method = findMethodByFulfillment(
    fulfillment.fulfillmentMethod,
    fulfillment
  );
  const zip = findZipCodeByFulfillment(
    fulfillment.fulfillmentMethod,
    fulfillment
  );

  return {
    method,
    store: storeId,
    zip,
  };
};

export const createCancelItemAnalytics = (
  itemIdList: array,
  lineItems: array,
  storeId: string = ONLINE_STORE_ID // '8119'
) =>
  itemIdList.map((id: string) => ({
    fulfillment: createCancelFulfillmentAnalytics(
      storeId,
      lineItems[id].fulfillment
    ),
    price: {
      basePrice: lineItems[id].totalPrice,
    },
    productInfo: {
      productName: lineItems[id].description,
      sku: lineItems[id].omsId,
      superSku: lineItems[id].omsId,
    },
    quantity: lineItems[id].currentQuantity,
  }));

export const createCancelOrderAnalytics = (
  orderId: string,
  totalPrice: string,
  item: [Object]
) => ({
  item,
  transactionId: orderId,
  price: totalPrice,
});

export const handleOnlineCancelAnalytics = ({
  orderId,
  totalPrice,
  itemIdList,
  lineItems,
  storeId = ONLINE_STORE_ID,
}: Object = {}) => {
  const postOrderAnalytics = createCancelOrderAnalytics(
    orderId,
    totalPrice,
    createCancelItemAnalytics(itemIdList, lineItems, storeId)
  );
  setCancellationSuccessPageInfo(postOrderAnalytics);
};

const pushCancelErrorCode = (header: string) => (error: Object) => {
  const message = `${header}${
    error.code === LINE_ITEM_ERROR_CODE ? CANCEL_LINE_ITEM : CANCEL_GENERAL
  }`;
  setErrorEvent(message, 'order cancellation', error.code);
};

export const handleCancelErrorAnalytics = (
  fulfillment: string,
  errors: [Object],
  lineItemErrors: [Object]
) => {
  if (fulfillment && fulfillment.toLowerCase() === 'buyonlinepickupinstore') {
    return setBopisCancelError();
  }
  if (!errors.length) {
    return setCancellationErrorPageInfo(CANCEL_GENERAL, 'GEN_ERROR');
  }
  return lineItemErrors.length
    ? lineItemErrors.forEach(pushCancelErrorCode('Were sorry'))
    : errors.forEach(pushCancelErrorCode('Were sorry. '));
};

export const createApplianceCancelPostOrder = (
  eligibleItems: Object,
  lineItems: Object,
  orderDetails: Object
) => {
  const {
    depotDirect,
    id,
    subTotal,
    shippingCharge,
    taxTotal,
    grandTotal,
  } = orderDetails;
  return {
    item: eligibleItems.map((eligibleItem: Object) => {
      const { lineReference } = eligibleItem;
      const lineItem = lineItems[lineReference];
      return {
        fulfillment: {
          method: 'appl',
          zip: depotDirect.zipCode,
        },
        price: {
          basePrice: lineItem.totalPrice,
        },
        productInfo: {
          productName: lineItem.description,
          sku: lineItem.storeSKU || '',
          superSku: lineItem.omsId || '',
        },
        quantity: lineItem.currentQuantity,
      };
    }),
    transactionID: id,
    price: {
      basePrice: subTotal,
      shipping: shippingCharge,
      tax: taxTotal,
      transactionTotal: grandTotal,
    },
  };
};
